import { appConfig } from "../config";
import type { ArErrorCode } from "../types";

export interface AnalyticsConfig {
  analyticsEnabled: boolean;
}

export type AnalyticsPayload = Record<string, unknown>;

export function createAnalyticsTracker(config: AnalyticsConfig = appConfig) {
  return (eventName: string, payload?: AnalyticsPayload): void => {
    if (!config.analyticsEnabled) {
      return;
    }

    console.info("[Converto WebAR]", eventName, payload ?? {});
  };
}

export const trackEvent = createAnalyticsTracker(appConfig);

export function trackArError(code: ArErrorCode, payload: AnalyticsPayload = {}): void {
  trackEvent("ar_error", { ...payload, code });
}
